import { formatAddress as formatLocalizedAddress } from 'localized-address-format';

export const formatAddress = (address, address2, city, province, cp, country, idCountry) => {
    const AMERICAN_FORMAT_COUNTRIES_IDS = [75, 42, 180, 146];
    const countryCode =
        idCountry && AMERICAN_FORMAT_COUNTRIES_IDS.includes(parseInt(idCountry, 10)) ? 'US' : 'ES';

    const addressLines = [];
    if (address) addressLines.push(address);
    if (address2) addressLines.push(address2);

    const formatted = formatLocalizedAddress({
        postalCountry: countryCode,
        administrativeArea: province || '',
        locality: city || '',
        postalCode: cp || '',
        addressLines,
    }).join(', ');

    return country ? `${formatted}, ${country}` : formatted;
};

export const formatAddressFromGeocoder = (
    address,
    streetNumber,
    postalCode,
    locality,
    state,
    region,
    country,
    countryIso,
    subpremise,
) => {
    address = address && address.trim();
    streetNumber = streetNumber && streetNumber.trim();
    postalCode = postalCode && postalCode.trim();
    locality = locality && locality.trim();
    state = state && state.trim();
    region = region && region.trim();
    country = country && country.trim();

    const addressLines = [];
    if (address) addressLines.push(address);
    if (streetNumber) addressLines.push(streetNumber);
    if (subpremise) addressLines.push(subpremise);

    const formatted = formatLocalizedAddress({
        postalCountry: countryIso || 'ES',
        administrativeArea: region || state || '',
        locality: locality || '',
        postalCode: postalCode || '',
        addressLines,
    }).join(', ');

    return country ? `${formatted}, ${country}` : formatted;
};

export const shouldFormatAddressAsAmericanIso = (countryIso) => {
    if (!countryIso) return false;
    return ['us', 'ca', 'gb', 'mx'].includes(countryIso.toLowerCase());
};
